/**
 * Page d'un lien personnel d'apprenant devenu inutilisable (expiré, remplacé, inconnu) : formulaire ou positionnement.
 * Même présentation pour les deux pages publiques — un titre, une explication, la marche à suivre — plutôt qu'un
 * simple bandeau d'erreur technique.
 */
import { Link2Off } from "lucide-react";
import { ErreurApi } from "../api";
import { useTitreDocument } from "./base";

const TEXTES = {
  formulaire: {
    autre: "Impossible d'ouvrir ce formulaire",
    aide: "Chaque lien reste valable jusqu’à son échéance, même si votre formateur vous a renvoyé le formulaire entre-temps. Si vous avez reçu plusieurs e-mails, essayez le plus récent ; sinon, demandez à votre formateur de vous le renvoyer : vous recevrez un nouveau lien.",
  },
  positionnement: {
    autre: "Impossible d'ouvrir ce positionnement",
    aide: "Chaque lien reste valable jusqu’à son échéance, même si votre formateur vous a relancé entre-temps. Si vous avez reçu plusieurs e-mails, essayez le plus récent ; sinon, demandez à votre formateur de vous inviter à nouveau : vous recevrez un nouveau lien.",
  },
} as const;

export function LienIndisponible({ erreur, objet = "formulaire" }: { erreur: Error; objet?: keyof typeof TEXTES }) {
  const perime = erreur instanceof ErreurApi && (erreur.statut === 404 || erreur.statut === 410);
  const t = TEXTES[objet];
  useTitreDocument("Lien indisponible");
  return (
    <div className="pt-16 text-center" role="status">
      <div className="mx-auto mb-4 grid size-14 place-items-center rounded-full bg-papier-3 text-encre-2">
        <Link2Off className="size-7" aria-hidden />
      </div>
      <h1 className="text-[22px] leading-tight font-semibold">{perime ? "Ce lien a expiré ou n'est pas valide" : t.autre}</h1>
      <p className="mx-auto mt-2 max-w-[44ch] text-encre-2">{perime ? t.aide : erreur.message}</p>
    </div>
  );
}
